import React from 'react'
import { Message } from 'mage-i18n'
import { TitleTertiary } from 'mage-deps/@klarna/bubble-ui'

export default function LoadingView() {
  return (
    <TitleTertiary id="uhqm-search-loading">
      <Message path="hqm.search.loading" fallback="Loading ..." />
    </TitleTertiary>
  )
}
